import Vue from 'vue'
import AppFesContainer from './AppFesContainer'
import AppFesHeader from './AppFesHeader'
import CreditCardFormFes from './CreditCardFormFes'
import FormCreditExpireFes from './FormCreditExpireFes'
import FormCreditCardFes from './FormCreditCardFes'
import FormInputFes from './FormInputFes'
import FormLabelFes from './FormLabelFes'

const uFes = {
  install(Vue, options) {
    Vue.component('app-fes-container', AppFesContainer)
    Vue.component('app-fes-header', AppFesHeader)
    Vue.component('credit-card-form-fes', CreditCardFormFes)
    Vue.component('form-credit-card-fes', FormCreditCardFes)
    Vue.component('form-credit-expire-fes', FormCreditExpireFes)
    Vue.component('form-input-fes', FormInputFes)
    Vue.component('form-label-fes', FormLabelFes)
  }
}

export default uFes



// WEBPACK FOOTER //
// ./resources/assets/js/uFes/components/index.js